<template>
  <div v-if="orders.length">
    <div
      v-for="(order, index) in orders"
      :key="`buyer-order-${index}`"
      class="pb-5"  
    >
      <div class="bg-white rounded-lg px-5">
        <div class="py-5 md:flex justify-between">
          <div class="flex md:block">
            <h3 class="font-semibold pr-1">Order Placed:</h3>
            <p>{{ handleDateFormatter(order.orderInformation.orderPlacedAt) }}</p>
          </div>
          <div class="flex md:block">
            <h3 class="font-semibold pr-1">Order Number:</h3>
            <p>{{ order.orderInformation.orderReferenceNumber }}</p>
          </div>
          <div class="flex md:block">
            <h3 class="font-semibold pr-1">Total:</h3>
            <p>{{ order.orderInformation.orderTotal }}</p>
          </div>
          <div v-if="order.orderType === 'sourcing'" class="flex md:block">
            <h3 class="font-semibold pr-1">Expected Due Date:</h3>
            <p >
              {{ handleDateFormatter(order.orderInformation.orderExpectedDueData) }}
            </p>
          </div>
          <div v-if="order.orderType === 'ecom'" class="flex md:block">
            <h3 class="font-semibold pr-1">Status:</h3>
            <p :class="setClass(order.orderInformation.status)">
              {{ order.orderInformation.status }}
            </p>
          </div>
          <div class="flex md:block pt-7.5 md:pt-0">
            <router-link
              v-if="order.orderType === 'ecom'"
              :to="`/profile/orders/${order.orderInformation.id}`"
              class="font-semibold underline text-blue"
            >
              Order Detail
            </router-link>
            <router-link
              v-else-if="order.orderType === 'sourcing'"
              :to="`/profile/sourcing-orders/${order.sourcingOrderDetails.sourcing_request_id}`"
              class="font-semibold underline text-blue"
            >
              Order Detail
            </router-link>
          </div>
        </div>
        <template v-if="order.orderType === 'ecom'">
          <div
            v-for="(product, index) in order.ecomOrderDetails"
            :key="`order-product-${index}`"
            class="md:flex py-5 border-t border-dark-b"
          >
            <img class="w-20 h-20" :src="product.images[0]">
            <div  class="md:pl-5 text-dark w-full">
              <router-link :to="`/${product.slug}`">
                {{ product.name }}
              </router-link>
              <div id="main_class_product">
                <div class="opacity-75 pt-5 text-sm">
                  <p>Price: {{ product.displayPrice }}</p>
                  <p>Quantity: {{ product.quantity }}</p>
                  <p>INCO terms: {{ product.incoTerms }}</p>
                  <p>
                    <span>Supplier:</span>
                    <router-link
                      :to="`/suppliers/${product.supplier.id}`"
                      class="text-blue-600"
                    >
                      {{ product.supplier.name }}
                    </router-link>
                  </p>
                </div>
                <div id="product_order_image" class="flex flex-col w-25 text-center pr-2 items-center pt-1 md:pt-0 pb-3 md:pb-1 md:justify-center"> 
                  <img 
                    src="@/assets/icons/orderCart.svg"
                    width="30"
                  >
                  <span class="leading-4 pt-1 font-semibold text-sm">Product Order</span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="order.orderType === 'sourcing'">
          <div class="md:flex py-5 border-t border-dark-b">
            <img
              v-if="order.sourcingOrderDetails.images.length > 0" 
              class="w-20 h-20" 
              :src="order.sourcingOrderDetails.images[0].pdf_cover_url ? order.sourcingOrderDetails.images[0].pdf_cover_url : order.sourcingOrderDetails.images[0].file_url"
            >
            <div class="md:pl-5 text-dark w-full">   
              <div id="main_class_sourcing">
                <div class="opacity-75 text-sm">
                  <p class="text-lg text-black">
                    {{ order.sourcingOrderDetails.product_category }}
                  </p>
                  <p>Sub-Category: </p>
                  {{ order.sourcingOrderDetails.product_sub_category }}
                  <p class="opacity-100 mt-4 text-sm">
                  Require Assistance? Contact us at: 
                  <a
                    :href="`mailto:${supportMail}`"
                    class="text-blue"
                  >
                    {{ supportMail }}
                  </a>
                </p>
                </div>
                
                <div id="sourcing_report_image" class="flex flex-col w-25 text-center items-center pt-1 md:pt-0 pb-3 md:pb-1 md:justify-end"> 
                    <img 
                      src="@/assets/icons/sourcingReport.svg"
                      width="30"
                    >
                    <span class="leading-4 pt-1 font-semibold text-sm">Sourcing Report</span> 
                </div>
                
              </div>
                
                
              
            </div>
            
          </div>
        </template>
        <div
          v-if="ordersStatus === 'Pending'"
          class="md:flex justify-end pb-5"
        >
          <!-- <button
            class="pending-button md:mx-2"
            @click="showOrder(order)"
          >Download Invoice</button> -->
          <button
            v-if="order.orderInformation.isValidForCancellation"
            class="pending-button md:mx-2"
            @click="openCancelModal(order)"
          >Cancel Order</button>
          <button
            v-if="order.orderInformation.isValidForSupport"
            class="pending-button md:mx-2"
            @click="openServiceRequestModal(order)"
          >Request Assistance</button>
        </div>
      </div>
    </div>
    <CancelOrderModal
      v-if="showCancelModal"
      :order="forOrder"
      @close="showCancelModal = false"
    />
    <ServiceRequestModal
      v-if="showRequestModal"
      :order="forOrder"
      @close="showRequestModal = false"
    />
  </div>
  <div v-else class="py-8 text-center">
    No order found.
  </div>
</template>
<script>
import moment from 'moment'
import CancelOrderModal from '@/shared/components/profile/order/CancelOrderModal'
import ServiceRequestModal from '@/shared/components/profile/order/ServiceRequestModal'

export default {
  name: 'OrdersList',
  props: {
    orders: {
      type: Array,
      default: () => []
    },
    ordersStatus: {
      default: 'Pending',
      type: String
    }
  },
  components: {
    CancelOrderModal,
    ServiceRequestModal
  },
  data() {
    return {
      isChatOpen: false,
      chatOrder: null,
      chatSupplier: null,
      showCancelModal: false,
      forOrder: null,
      showRequestModal: false,
      supportMail: process.env.VUE_APP_SUPPORT_MAIL
    }
  },
  methods: {
    chatWithSupplier(order, supplier) {
      this.isChatOpen = true
      this.chatOrder = order
      this.chatSupplier = supplier
    },
    closeChat() {
      this.isChatOpen = false
      this.chatSupplier = null
    },
    showOrder(order) {
      console.log(order, order.orderInformation)
    },
    openCancelModal(order) {
      this.forOrder = order
      this.showCancelModal = true
    },
    openServiceRequestModal(order) {
      this.forOrder = order
      this.showRequestModal = true
    },
    setClass(status) {
      if (status === 'Delivered') {
        return 'text-green'
      } else if (status === 'Canceled') {
        return 'text-red-500'
      }
      return 'text-blue'
    },
    handleDateFormatter (date) {
      return moment(date).format('DD/MM/YYYY')
    }
  }
}
</script>
<style lang="scss" scoped>
  .pending-button {
    @apply bg-dark-b py-2.5 px-6 rounded-full text-dark font-semibold w-full mb-2;
    @screen md { @apply w-auto }
  }
  @media screen and (max-width: 480px) {
    #product_order_image {
      align-items: flex-end;
      text-align: end;
      padding-right: 0;
    }
    #sourcing_report_image {
      align-items: flex-end;
      text-align: end;
    }
    #main_class_sourcing {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    #main_class_product {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  @media screen and (min-width: 480px) {
    #main_class_sourcing {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    #main_class_product {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

  }
</style>